/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectActivityResourcePastEventsInnerAuthor } from './';
import {
    ProjectActivityResourcePastEventsInnerAuthorFromJSON,
    ProjectActivityResourcePastEventsInnerAuthorFromJSONTyped,
    ProjectActivityResourcePastEventsInnerAuthorToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectActivityResourcePastEventsInner
 */
export interface ProjectActivityResourcePastEventsInner {
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    eventType: ProjectActivityResourcePastEventsInnerEventTypeEnum;
    /**
     * 
     * @type {ProjectActivityResourcePastEventsInnerAuthor}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    author: ProjectActivityResourcePastEventsInnerAuthor;
    /**
     * 
     * @type {Date}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    eventDate: Date;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    extraData: { [key: string]: string; };
}


/**
 * @export
 */
export const ProjectActivityResourcePastEventsInnerEventTypeEnum = {
    ClientAppraisedFreelancer: 'CLIENT_APPRAISED_FREELANCER',
    ContractAccepted: 'CONTRACT_ACCEPTED',
    ContractCancelled: 'CONTRACT_CANCELLED',
    ContractProposed: 'CONTRACT_PROPOSED',
    ExpenseApproved: 'EXPENSE_APPROVED',
    ExpenseBlocked: 'EXPENSE_BLOCKED',
    ExpensePaid: 'EXPENSE_PAID',
    ExpenseSubmitted: 'EXPENSE_SUBMITTED',
    InvoiceEmailSent: 'INVOICE_EMAIL_SENT',
    InvoiceEmitted: 'INVOICE_EMITTED',
    InvoiceLateEmailSent: 'INVOICE_LATE_EMAIL_SENT',
    InvoiceLateFormalNoticeEmailSent: 'INVOICE_LATE_FORMAL_NOTICE_EMAIL_SENT',
    InvoiceLateFormalNoticeReminderEmailSent: 'INVOICE_LATE_FORMAL_NOTICE_REMINDER_EMAIL_SENT',
    InvoiceLetterSent: 'INVOICE_LETTER_SENT',
    LotCompleted: 'LOT_COMPLETED',
    LotCompletedAutomatically: 'LOT_COMPLETED_AUTOMATICALLY',
    LotEditedByAdmin: 'LOT_EDITED_BY_ADMIN',
    LotEstimated: 'LOT_ESTIMATED',
    LotValidationDocumentEmitted: 'LOT_VALIDATION_DOCUMENT_EMITTED',
    ManagerUpdated: 'MANAGER_UPDATED',
    PaymentLotTransactionPaid: 'PAYMENT_LOT_TRANSACTION_PAID',
    PaymentTransactionPaid: 'PAYMENT_TRANSACTION_PAID',
    PaymentTransactionRefunded: 'PAYMENT_TRANSACTION_REFUNDED',
    PrepaymentLateEmailSent: 'PREPAYMENT_LATE_EMAIL_SENT',
    ProjectCancelled: 'PROJECT_CANCELLED',
    ProjectClosed: 'PROJECT_CLOSED',
    ProjectCompleted: 'PROJECT_COMPLETED',
    ProjectCompletedAutomatically: 'PROJECT_COMPLETED_AUTOMATICALLY',
    ProjectCompletionRequested: 'PROJECT_COMPLETION_REQUESTED',
    QuoteAccepted: 'QUOTE_ACCEPTED',
    QuoteAmended: 'QUOTE_AMENDED',
    QuoteCreated: 'QUOTE_CREATED',
    RenewalAcceptedByFreelancer: 'RENEWAL_ACCEPTED_BY_FREELANCER',
    RenewalApproved: 'RENEWAL_APPROVED',
    RenewalInitiated: 'RENEWAL_INITIATED',
    RenewalRefusedByClient: 'RENEWAL_REFUSED_BY_CLIENT',
    RenewalRefusedByFreelancer: 'RENEWAL_REFUSED_BY_FREELANCER'
} as const;
export type ProjectActivityResourcePastEventsInnerEventTypeEnum = typeof ProjectActivityResourcePastEventsInnerEventTypeEnum[keyof typeof ProjectActivityResourcePastEventsInnerEventTypeEnum];


/**
 * Check if a given object implements the ProjectActivityResourcePastEventsInner interface.
 */
export function instanceOfProjectActivityResourcePastEventsInner(value: object): value is ProjectActivityResourcePastEventsInner {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('author' in value) || value['author'] === undefined) return false;
    if (!('eventDate' in value) || value['eventDate'] === undefined) return false;
    if (!('extraData' in value) || value['extraData'] === undefined) return false;
    return true;
}

export function ProjectActivityResourcePastEventsInnerFromJSON(json: any): ProjectActivityResourcePastEventsInner {
    return ProjectActivityResourcePastEventsInnerFromJSONTyped(json, false);
}

export function ProjectActivityResourcePastEventsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectActivityResourcePastEventsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': json['eventType'],
        'author': ProjectActivityResourcePastEventsInnerAuthorFromJSON(json['author']),
        'eventDate': (new Date(json['eventDate'])),
        'extraData': json['extraData'],
    };
}

export function ProjectActivityResourcePastEventsInnerToJSON(value?: ProjectActivityResourcePastEventsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventType': value['eventType'],
        'author': ProjectActivityResourcePastEventsInnerAuthorToJSON(value['author']),
        'eventDate': ((value['eventDate']).toISOString()),
        'extraData': value['extraData'],
    };
}

